<template>
  <v-container class="d-flex flex-column justify-between overflow-auto">
    <p class="title" v-if="estimateClientChoice || estimateClientChoiceValidation">{{ $t('ESTIMATE_REPAIRER.TITLE_CHOICE') }}</p>
    <p class="title" v-else>{{ $t('ESTIMATE_REPAIRER.TITLE') }}</p>
    <div class="container">
      <EstimateRepairerCreation
        :currentRepairFile="currentRepairFile"
        v-if="estimateInCreation"
        @cancelEstimateRepairer="handleCancelEstimateRepairer()"
        @nextStepEstimateInOffer="nextStepEstimateInOffer()"
        class="pa-0"
      />
      <EstimateRepairerOffer
        @cancelEstimateRepairer="handleCancelEstimateRepairer()"
        @updateCurrentRepairFile="handleUpdateCurrentRepairFile()"
        @openEstimateRepairerDetail="handleOpenEstimateRepairerDetail()"
        :currentRepairFile="currentRepairFile"
        v-if="estimateInOffer"
        class="pa-0"
      />
      <EstimateRepairerDetail
        @cancelEstimateRepairer="handleCancelEstimateRepairer()"
        @closeNewAction="handleCloseNewAction()"
        @updateCurrentRepairFile="handleUpdateCurrentRepairFile()"
        @openEstimateRepairerClientChoice="handleOpenEstimateRepairerClientChoice()"
        @backToRepairerOffersCreation="handleBackToRepairerOffersCreation()"
        :currentRepairFile="currentRepairFile"
        v-if="estimateInDetail"
        class="pa-0"
      />
      <EstimateRepairerClientChoice
        @cancelEstimateRepairer="handleCancelEstimateRepairer()"
        @openEstimateRepairerClientChoiceValidation="handleOpenEstimateRepairerClientChoiceValidation()"
        @closeNewAction="handleCloseNewAction()"
        @updateCurrentRepairFile="handleUpdateCurrentRepairFile()"
        :currentRepairFile="currentRepairFile"
        v-if="estimateClientChoice"
        class="pa-0"
      />
      <EstimateRepairerClientChoiceValidation
        @cancelEstimateRepairer="handleCancelEstimateRepairer()"
        @updateCurrentRepairFile="handleUpdateCurrentRepairFile()"
        :currentRepairFile="currentRepairFile"
        v-if="estimateClientChoiceValidation"
        class="pa-0"
      />
    </div>
  </v-container>
</template>


<script>
import EstimateRepairerCreation
  from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/EstimateRepairer/EstimateRepairerCreation.vue';
import EstimateRepairerOffer
  from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/EstimateRepairer/EstimateRepairerOffer.vue';
import EstimateRepairerDetail
  from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/EstimateRepairer/EstimateRepairerDetail.vue';
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant';
import EstimateRepairerClientChoice
  from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/EstimateRepairer/EstimateRepairerClientChoice.vue';
import EstimateRepairerClientChoiceValidation
  from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/EstimateRepairer/EstimateRepairerClientChoiceValidation.vue';
import { RepairFile } from '@/models/RepairFile'

export default {
  components: {
    EstimateRepairerClientChoice,
    EstimateRepairerCreation,
    EstimateRepairerOffer,
    EstimateRepairerDetail,
    EstimateRepairerClientChoiceValidation
  },
  props: {
    currentRepairFile: RepairFile
  },
  data() {
    return {
      loading: false,
      repairerRepairFileNumber: null,
      estimateInCreation: true,
      estimateInOffer: false,
      estimateInDetail: false,
      estimateClientChoice: false,
      estimateClientChoiceValidation: false
    }
  },
  created() {
    if (this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.ESTIMATE_CREATED) {
      this.estimateInCreation = false
      this.estimateInDetail = true
    }
    if (this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER) {
      this.estimateInCreation = false
      this.estimateClientChoice = true
    }
  },
  unmounted() {
    this.estimateInCreation = true
    this.estimateInOffer = false
    this.estimateInDetail = false
    this.estimateClientChoice = false
    this.estimateClientChoiceValidation = false
  },
  methods: {

    handleCancelEstimateRepairer() {
      this.estimateInCreation = true
      this.estimateInOffer = false
      this.cancelEstimateRepairer()
    },
    nextStepEstimateInOffer() {
      this.estimateInCreation = false
      this.estimateInOffer = true
      this.$emit('updateCurrentRepairFile')
    },
    handleOpenEstimateRepairerDetail() {
      this.estimateInCreation = false
      this.estimateInOffer = false
      this.estimateInDetail = true
    },
    handleOpenEstimateRepairerClientChoice() {
      this.estimateInDetail = false
      this.estimateClientChoice = true
    },
    handleOpenEstimateRepairerClientChoiceValidation() {
      this.estimateClientChoice = false
      this.estimateClientChoiceValidation = true
    },
    cancelEstimateRepairer() {
      this.$emit('cancelEstimateRepairer')
    },
    handleUpdateCurrentRepairFile() {
      this.$emit('updateCurrentRepairFile')
    },
    handleCloseNewAction() {
      this.$emit('closeNewAction')
    },
    handleBackToRepairerOffersCreation() {
      this.$emit('updateCurrentRepairFile')
      this.estimateInCreation = false
      this.estimateInOffer = true
      this.estimateInDetail = false
      this.estimateClientChoice = false
      this.estimateClientChoiceValidation = false
    }
  }
}
</script>

<style scoped>
.container {
  height: calc(100vh - 173px);
}

.title {
  color: #000;
  text-align: center;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 40px;
}
</style>
